import React, { Component } from 'react';
import Results from './Results/Results';
import Filters from '../Filters/Filters';
import mixpanel from '../../../utils/mixpanel';
import './Body.scss';

export default class Body extends Component {
    componentDidMount() {
        mixpanel.track('Search page mounted');
    }

    render() {
        return (
            <div className="emvio-search-body">
                <div className="results-wrapper">
                    <Filters />
                    <Results />
                </div>
            </div>
        );
    }
}
